import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    name = 'oracleServices',
    exports = storeModuleFactory({
        name,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        endpoint: endpoints.services.oracleServices.endpoint
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/oracleServices.js